module.exports = __webpack_public_path__ + "img/acquiring.c06bb512.png";